import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';

export default function RenewCount({ count }) {
  return (
    <div className="cp-renew-count">
      <FormattedMessage id="renewed" /> <FormattedMessage id="times_renewed" values={{ count }} />
    </div>
  );
}

RenewCount.propTypes = {
  count: PropTypes.number
};



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/RenewCount/RenewCount.jsx